// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunMetricItem
 */
export interface RunMetricItem {
    /**
     * 
     * @type {string}
     * @memberof RunMetricItem
     */
    date: string;
    /**
     * 
     * @type {number}
     * @memberof RunMetricItem
     */
    failed: number;
    /**
     * 
     * @type {number}
     * @memberof RunMetricItem
     */
    passed: number;
}

/**
 * Check if a given object implements the RunMetricItem interface.
 */
export function instanceOfRunMetricItem(value: object): value is RunMetricItem {
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('failed' in value) || value['failed'] === undefined) return false;
    if (!('passed' in value) || value['passed'] === undefined) return false;
    return true;
}

export function RunMetricItemFromJSON(json: any): RunMetricItem {
    return RunMetricItemFromJSONTyped(json, false);
}

export function RunMetricItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunMetricItem {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'],
        'failed': json['failed'],
        'passed': json['passed'],
    };
}

export function RunMetricItemToJSON(json: any): RunMetricItem {
    return RunMetricItemToJSONTyped(json, false);
}

export function RunMetricItemToJSONTyped(value?: RunMetricItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'failed': value['failed'],
        'passed': value['passed'],
    };
}
